const yodleeManualScript = (() => {
    let linkedList, yodleeConfigObj = {}, widget_service_api = '', document_upload_url = '';
    let promiseResolve; 
    let promiseReject;
    const yodleeManualDefaultConfig = {
        uploadedDocsCount: 0
    };
    let widgetPromise = new Promise((resolve, reject) => {
        promiseResolve = resolve;
        promiseReject = reject;
    });
    let analyser_status = { "ignoreParsingError": false, "hideManualDiv":false };

    /**
     * main : returning yodlee-manual-template
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param obj object
     */
    const main = (obj) => {
        widget_service_api = obj.widget_service_api;
        document_upload_url = obj.document_upload_url;
        Object.assign(yodleeConfigObj, obj.body);
        Object.assign(yodleeManualDefaultConfig, obj);
        yodleeManualDefaultConfig.slugs = obj.slugs || {};

        if(yodleeManualDefaultConfig.body.yodleeManual.analyser_status){
            analyser_status.ignoreParsingError = (true == yodleeManualDefaultConfig.body.yodleeManual.analyser_status.ignoreParsingError)?yodleeManualDefaultConfig.body.yodleeManual.analyser_status.ignoreParsingError : false;
            analyser_status.hideManualDiv = (true == yodleeManualDefaultConfig.body.yodleeManual.analyser_status.hideManualDiv)?yodleeManualDefaultConfig.body.yodleeManual.analyser_status.hideManualDiv : false;
        }
        // console.log(analyser_status)
        yodleeManualDefaultConfig.security_option = yodleeManualDefaultConfig.body["security"] || {};

        initOptions(yodleeManualDefaultConfig.widget_service_api);

        linkedList = new LinkedList();
        const options = initScript.methodWiseOption(yodleeManualDefaultConfig.options.yodlee_manual_template.method, {
            url: yodleeManualDefaultConfig.options.yodlee_manual_template.url,
            data: JSON.stringify((yodleeConfigObj.yodleeManual && yodleeConfigObj.yodleeManual.html) ? yodleeConfigObj.yodleeManual.html : {}),
            headers: { "Content-Type": "application/json" },
            processData: false
        }, yodleeManualDefaultConfig.security_option);

        HttpRequest(options, (res) => {
            res = (typeof res === "string") ? res : responseV2Interceptor(res, yodleeManualDefaultConfig.slugs["yodlee-manual-template"], false);
            appendTemplate(res);
        });
    };

    /**
     * initOptions : initializing option config
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param API_URL string
     */
    const initOptions = (API_URL) => {
        yodleeManualDefaultConfig.options = {
            yodlee_manual_template: {
                url: getV2URL(API_URL, "yodlee-manual-template", yodleeManualDefaultConfig.slugs),
                method: "POST",
            },
            yodlee_document_upload: {
                url: getV2URL(document_upload_url ? document_upload_url : API_URL, "yodlee-document-upload", yodleeManualDefaultConfig.slugs),
                // url: getV2URL(API_URL, "yodlee-document-upload", yodleeManualDefaultConfig.slugs),
                method: "POST",
            },
            yodleeTransactionIds: {
                url: getV2URL(API_URL, "yodleeTransactionIds", yodleeManualDefaultConfig.slugs),
                method: 'GET',
            },
            submitYodleeForm: {
                url: getV2URL(API_URL, "submitYodleeForm", yodleeManualDefaultConfig.slugs),
                method: 'POST',
            },
            classifyDocs: {
                url: getV2URL(API_URL, "classify-docs", yodleeManualDefaultConfig.slugs),
                method: 'POST'
            },
            openYodleeModel: {
                // url: API_URL + '/openYodleeModel' + '?internal=true',
                url: getV2URL(API_URL, "openYodleeModel", yodleeManualDefaultConfig.slugs),
                method: 'GET'
            },
            analyserUploadedDocs: {
                url: getV2URL(API_URL, "analyser-uploaded-docs", yodleeManualDefaultConfig.slugs),
                method: 'POST'
            },
            classifyUploadedDocs: {
                url: getV2URL(API_URL, "classify-uploaded-docs", yodleeManualDefaultConfig.slugs),
                method: 'POST'
            },
            deleteuploadeddocsmanualreference: {
                url: getV2URL(API_URL, "delete-uploaded-docs-manual-reference", yodleeManualDefaultConfig.slugs),
                method: 'POST'
            },
            deleteUploadedDocsBusiness: {
                url: getV2URL(API_URL, "deleteUploadedDocsBusiness", yodleeManualDefaultConfig.slugs),
                method: 'POST'
            },
            deleteUploadedDocsManual: {
                url: getV2URL(API_URL, "deleteUploadedDocsManual", yodleeManualDefaultConfig.slugs),
                method: yodleeManualDefaultConfig.slugs.deleteUploadedDocsManual? "POST" : "DELETE",
            }
        };
    };

    /**
     * toggleTargetProperty : disabling target elements by property
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param flag boolean
     * @param hideFile boolean
     */
    const toggleTargetProperty = (flag = true, hideFile = false) => {
        flag = (linkedList.size_of_list() === 0) | flag;
        if (hideFile) {
            initScript.disableElementByProp('#fileCall', hideFile);
            initScript.getHTMLElementByDelimiter('widgetLoaderWrapper').remove();
            initScript.disableElementByProp('#uploadFileID', flag);
        }
        initScript.disableElementByProp('#submitUploadedFilesId', flag);
    };

    /**
     * appendTemplate : appending template on yodleeManual class
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param template string
     */
    const appendTemplate = (template) => {
        $(`.${yodleeConfigObj.yodleeManual.class}`)[0].innerHTML = template;
        bindTemplateFunctions();
        // Google.init(yodleeManualDefaultConfig);
    };

    /**
     * uploadFile : uploading a single file
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param file File
     * @param requestOptions robject
     * @param callback Function
     */
    const uploadFile = (file, requestOptions, callback) => {
        HttpRequest(requestOptions, res => {
            res = typeof res === "string" ? JSON.parse(res) : res;
            res = responseV2Interceptor(res, yodleeManualDefaultConfig.slugs["yodlee-document-upload"]);
            appendFilesToList(file, res.ref_id);
            callback(res);
        });
    };

    /**
     * uploadFiles : uploading multiple files
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param files File
     */
    const uploadFiles = (files) => {
        if(files.length > 0){
            initScript.toggleLoader(true);
        }
        hideNonPDFErrorMessage();
        yodleeManualDefaultConfig.uploadedDocsCount = 0;
        for (let i = 0; i < files.length; ++i) {
            const form = new FormData();
            if (widget_service_api.search(/orch/gm) !== -1 && !Object.keys(yodleeManualDefaultConfig.slugs).length) {
                form.append("file_name", files[i]);
                form.append("filekey", 'file');
            } else form.append("file", files[i]);
            form.append("user_id", yodleeConfigObj.yodleeManual.user_id);
            form.append("app_id", yodleeConfigObj.yodleeManual.app_id);
            form.append("provider[auto]", yodleeConfigObj.yodleeManual.provider['auto']);
            form.append("provider[manual]", yodleeConfigObj.yodleeManual.provider['manual']);
            form.append("provider[document-management]", yodleeConfigObj.yodleeManual.provider['document-management']);
            form.append("type", yodleeConfigObj.yodleeManual.type);
            form.append("mimeType", 'multipart/form-data');
            form.append("doc_type_id", yodleeConfigObj.yodleeManual.doc_type_id);
            if(yodleeConfigObj.yodleeManual.doc_type_key){
                form.append("doc_type_key", yodleeConfigObj.yodleeManual.doc_type_key);
            }
            if(yodleeConfigObj.yodleeManual.service_config){
                form.append("service_config", JSON.stringify(yodleeConfigObj.yodleeManual.service_config));
            }

            const options = initScript.methodWiseOption(yodleeManualDefaultConfig.options.yodlee_document_upload.method, {
                url: yodleeManualDefaultConfig.options.yodlee_document_upload.url,
                mimeType: "multipart/form-data",
                data: form,
                processData: false,
                contentType: false
            }, yodleeManualDefaultConfig.security_option);
          
            if (files[i].type == 'application/pdf' || analyser_status.ignoreParsingError) {
                uploadFile(files[i], options, res => {
                    yodleeManualDefaultConfig.uploadedDocsCount++;
                    res = responseInterceptor(res);
                    if (!!res.code && res.code >= 400) {
                        initScript.getTargetIdentifierElement('#Failure').innerHTML =  res.errors[0].message;
                        initScript.getHTMLElementByDelimiter('Failure', '#').css('display', 'block');
                        // showNonPDFErrorMessage();
                        initScript.toggleLoader(false);
                    } else if (yodleeManualDefaultConfig.uploadedDocsCount === files.length) initScript.toggleLoader(false);
                });
            }else{
                showNonPDFErrorMessage();
                initScript.toggleLoader(false);
            }
        }
    };

    /**
     * getDownloadedFile : getting uploading files data
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const getDownloadedFile = () => {
        initScript.toggleLoader(true);
        const query = initScript.generateQueryParams({
            app_id: yodleeConfigObj.yodleeManual.app_id,
            user_id: yodleeConfigObj.yodleeManual.user_id,
            provider: yodleeConfigObj.yodleeManual.provider['document-management']
        });

        const options = initScript.methodWiseOption('GET', {
            url: widget_service_api + '/getDownloadedFile' + '?' + query + '?internal=true'
        }, yodleeManualDefaultConfig.security_option);

        HttpRequest(options, res => {
            res = responseInterceptor(res);
            // extractDownloadedFiles(res);
        });
    };

    /**
     * downloadFile : downloading file with required parameters
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param doc_id string
     * @param callback Function
     */
    const downloadFile = (doc_id, callback) => {
        const options = initScript.methodWiseOption('GET', {
            url: widget_service_api + '/downloadFile/' + doc_id + '?internal=true',
        }, yodleeManualDefaultConfig.security_option);

        HttpRequest(options, res => {
            res = responseInterceptor(res);
            callback(res);
        });
    };

    /**
     * extractDownloadedFiles : downloading file and showing on list
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param downloadedFileResponse string
     */
    const extractDownloadedFiles = (downloadedFileResponse) => {
        if (!!!downloadedFileResponse || !!!downloadedFileResponse.data || !!!downloadedFileResponse.data.length) initScript.toggleLoader(false);
        let count = 0;
        for (let i = 0; i < downloadedFileResponse.data.length; ++i) {
            downloadFile(downloadedFileResponse.data[i].ref_id, res => {
                if (!!res && !!res.data) {
                    /*initScript.urlToFile('data:application/pdf;base64,' + res.data, downloadedFileResponse.data[i].response.data.filename, 'application/pdf').then(file => {
                        linkedList.add(file, downloadedFileResponse.data[i].ref_id);
                        showFilesList(downloadedFileResponse.data[i].response.data.filename, linkedList.size_of_list() - 1);
                        if (++count === downloadedFileResponse.data.length) initScript.toggleLoader(false);
                    });*/
                }
            });
        }
    };

    /**
     * appendFilesToList : appending file on list
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param file File
     * @param id string
     */
    const appendFilesToList = (file, id) => {
        if (file.name.split('.')[file.name.split('.').length - 1] !== 'pdf' && false == analyser_status.ignoreParsingError) return;
        linkedList.add(file, id);
        showFilesList(file.name, linkedList.size_of_list() - 1);
    };

    /**
     * analyserUploadedDocsUtil : analysing uploaded doc
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param file File
     * @param doc_id string
     */
    const analyserUploadedDocsUtil = (file, doc_id) => {
        hideNonPDFErrorMessage();
        initScript.getHTMLElementByDelimiter('doneMessageID', '#').css('display', 'none');
        const form = new FormData();
        let file_key = "upload_file";
        if (Object.keys(yodleeManualDefaultConfig.slugs).length) file_key = "file";
        else if (widget_service_api.search(/orchbase/gm) !== -1) file_key = "file_name";
        form.append(file_key, file);
        form.append("filekey", 'upload_file');
        form.append("ref_id", doc_id);
        form.append("user_id", yodleeConfigObj.yodleeManual.user_id);
        form.append("app_id", yodleeConfigObj.yodleeManual.app_id);
        form.append("provider[auto]", yodleeConfigObj.yodleeManual.provider['auto']);
        form.append("provider[manual]", yodleeConfigObj.yodleeManual.provider['manual']);
        form.append("provider[document-management]", yodleeConfigObj.yodleeManual.provider['document-management']);
        //  form.append("type", yodleeConfigObj.yodleeManual.type);
        form.append("type", "file");
        form.append("doc_type_id", yodleeConfigObj.yodleeManual.doc_type_id);
        if(yodleeConfigObj.yodleeManual.doc_type_key){
            form.append("doc_type_key", yodleeConfigObj.yodleeManual.doc_type_key);
        }

        const options = initScript.methodWiseOption(yodleeManualDefaultConfig.options.analyserUploadedDocs.method, {
            url: yodleeManualDefaultConfig.options.analyserUploadedDocs.url,
            mimeType: "multipart/form-data",
            data: form,
            processData: false,
            contentType: false
        }, yodleeManualDefaultConfig.security_option);

        return new Promise((resolve, reject) => {
            HttpRequest(options, (res) => {
                res = typeof res === "string" ? JSON.parse(res) : res;
                let result = responseV2Interceptor(res,yodleeManualDefaultConfig.slugs['analyser-uploaded-docs']);
                if(result.analyserResponse.errors){
                    reject(result);
                }
                else{
                    // initScript.getTargetIdentifierElement('#doneMessageID').innerHTML =  'Thanks for submitting your details, Please close the browser.';
                    // document.getElementById("doneMessageID").style.color = "black";
                    resolve(result);
                }
            });
        });
    };

    /**
     * analyserUploadedDocs : analysing uploaded docs
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const analyserUploadedDocs = () => {
        const tasks = [];
        for (let i = 0; i < linkedList.size_of_list(); ++i) {
            const node = linkedList.getAt(i);
            tasks.push(analyserUploadedDocsUtil(node.val, node.id));
        }
        return Promise.all(tasks);
    };

    /**
     * classifyUploadedDocs : classify uploaded docs
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const classifyUploadedDocs = () => {
        const options = initScript.methodWiseOption(yodleeManualDefaultConfig.options.classifyUploadedDocs.method, {
            url: yodleeManualDefaultConfig.options.classifyUploadedDocs.url,
            data: {
                user_id: yodleeConfigObj.yodleeManual.user_id,
                app_id: yodleeConfigObj.yodleeManual.app_id,
                provider: {
                    auto: yodleeConfigObj.yodleeManual.provider['auto'],
                    manual: yodleeConfigObj.yodleeManual.provider['manual'],
                    'document-management': yodleeConfigObj.yodleeManual.provider['document-management'],
                },
                type: yodleeConfigObj.yodleeManual.type,
                doc_type_id: yodleeConfigObj.yodleeManual.doc_type_id
            }
        }, yodleeManualDefaultConfig.security_option);

        HttpRequest(options, (res) => {
            initScript.toggleLoader(false);
            $('#doneMessageID').css('display', 'block');
            toggleTargetProperty(true, true);
            $(".close").off("click");
            promiseResolve({
                code: 200,
                type: 'manual',
                status: 'success',
                data: res
            });
        });
    };

    /**
     * deleteSelectedFileManual : deleting doc from manual
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param idx number
     * @param flag boolean
     */
    const deleteSelectedFileManual = (idx, flag = false) => {
        initScript.toggleLoader(true);
        const linkedListNode = linkedList.getAt(idx);
        const query = initScript.generateQueryParams({
            doc_id: linkedListNode.id
        });
        const options = initScript.methodWiseOption(yodleeManualDefaultConfig.options.deleteUploadedDocsManual.method, {
            url: yodleeManualDefaultConfig.slugs.deleteUploadedDocsManual ?  yodleeManualDefaultConfig.options.deleteUploadedDocsManual.url + '&' + query:  widget_service_api + "/deleteUploadedDocsManual/" + linkedListNode.id + '?internal=true',
        }, yodleeManualDefaultConfig.security_option);

        HttpRequest(options, (res) => {
            initScript.getTargetIdentifierElement('#Failure').innerHTML =  '';
            res = responseV2Interceptor(res, yodleeManualDefaultConfig.slugs["deleteUploadedDocsManual"]);
            if (!flag) initScript.toggleLoader(false);
            if (res.code !== 400 || res.data.code !== 400) {
                deleteSelectedBusinessFile(idx, linkedListNode.id);
            }
        });
    };

    /**
     * deleteSelectedFileManual : deleting doc from business
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param idx number
     * @param id string
     */
    const deleteSelectedBusinessFile = (idx, id) => {
        const options = initScript.methodWiseOption('POST', {
            url: yodleeManualDefaultConfig.options.deleteUploadedDocsBusiness.url,
            // url: widget_service_api + "/deleteUploadedDocsBusiness" + '?internal=true',
            data: {
                doc_id: id
            }
        }, yodleeManualDefaultConfig.security_option);

        HttpRequest(options, (res) => {
            linkedList.removeFrom(idx);
            toggleTargetProperty(!!!linkedList.size_of_list());
            $('#uploadedFile' + idx).remove();
            initScript.toggleLoader(false);
        });
    };

    /**
     * deleteSelectedFileManual : displaying files
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param file File
     * @param idx number
     */
    const showFilesList = (file, idx) => {
        toggleTargetProperty(!!!linkedList.size_of_list());
        const uploadedFiles = $('.uploadedFiles');
        uploadedFiles.append('<div class="uploadBox fontSize-14 font-weight-bold" id="uploadedFile' + idx + '" data-val="' + idx + '">\n' +
            '                        <div  class="font-weight-bold">Uploaded</div>\n' +
            '                        <div  class="row mt-25">\n' +
            '                            <div  class="col-10 col-sm-11">\n' +
            '                                <div  class="d-flex justify-content-between mb-14 mb-32-mobile">\n' +
            '                                    <div  class="fileName">' + file + '</div>\n' +
            '                                    <div class="silverChalice position-sm-absolute b-50-mobile"></div>\n' +
            '                                    <button  aria-label="Close" id="deleteSelectedBusinessFileID' + idx + '" class="close font-weight-normal" type="button">\n' +
            '<span aria-hidden="true">×</span>' +
            '                                    </button>\n' +
            '                                </div>\n' +
            '                                <div  class="progress">\n' +
            '                                    <div  aria-valuemax="100" aria-valuemin="0" aria-valuenow="0"\n' +
            '                                          class="progress-bar" role="progressbar" style="width: 100%;"></div>\n' +
            '                                </div>\n' +
            '                                <div  class="d-flex justify-content-between silverChalice ">\n' +
            '                                    <div >100% done</div>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                        </div>\n' +
            '                    </div>');
        $('#deleteSelectedBusinessFileID' + idx).on('click', () => {
            deleteSelectedFileManual(idx, true);
        });
    };

    /**
     * hideNonPDFErrorMessage : hide none error message
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const hideNonPDFErrorMessage = () => {
        yodleeManualDefaultConfig.nonPDFFileErrorMessage.css('display', 'none');
    };
    /**
     * showNonPDFErrorMessage : show none error message
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const showNonPDFErrorMessage = () => {
        yodleeManualDefaultConfig.nonPDFFileErrorMessage.css('display', 'block');
        // autoCallAFunctionByExpectedTime();
    };
    /**
     * autoCallAFunctionByExpectedTime : call a function after given time
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const autoCallAFunctionByExpectedTime = (time = 10000) => {
        setTimeout(() => {
            hideNonPDFErrorMessage();
        }, time)
    };
    /**
     * bindClickEvents : binding target identifiers click events
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const bindClickEvents = () => {
    };
    /**
     * bindTemplateFunctions : binding target identifiers
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const bindTemplateFunctions = () => {
        toggleTargetProperty();
        const dragBox = $('.dragBox');
        dragBox.on("dragover", function (event) {
            event.preventDefault();
            event.stopPropagation();
        });

        dragBox.on("dragleave", function (event) {
            event.preventDefault();
            event.stopPropagation();
        });

        dragBox.on("drop", function (event) {
            event.preventDefault();
            event.stopPropagation();
            uploadFiles(event.originalEvent.dataTransfer.files);
        });
        $('#submitUploadedFilesId').on('click', () => {
            submitFiles();
        });
        $('.closeYodleeManualUploadModal').on('click', () => {
            hideManualDiv(yodleeConfigObj.yodleeManual.class, yodleeConfigObj.yodleeManual.html.modal);
        });
        $("."+yodleeConfigObj.yodleeManual.class+' :input[type="file"]').change(function (e) {
            //console.log("in"+yodleeConfigObj.yodleeManual.class)
            uploadFiles(e.target.files);
        });
        yodleeManualDefaultConfig.submitUploadedFilesId = initScript.getHTMLElementByDelimiter('submitUploadedFilesId', '#');
        yodleeManualDefaultConfig.nonPDFFileErrorMessage = initScript.getHTMLElementByDelimiter('nonPDFFileErrorMessage');
        initScript.appendCSS(yodleeConfigObj.yodleeManual);
        bindClickEvents();
        // getDownloadedFile();
    };

    /**
     * deleteManualReferences : deleting manual references
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const deleteManualReferences = () => {
        initScript.toggleLoader(true);
        const options = initScript.methodWiseOption('POST', {
            // url: yodleeManualDefaultConfig.options.classifyUploadedDocs.url,
            url: widget_service_api + "/delete-uploaded-docs-manual-reference" + '?internal=true',
            method: "POST",
            data: {
                user_id: yodleeConfigObj.yodleeManual.user_id,
                app_id: yodleeConfigObj.yodleeManual.app_id,
                provider: {
                    auto: yodleeConfigObj.yodleeManual.provider['auto'],
                    manual: yodleeConfigObj.yodleeManual.provider['manual']
                }
            }
        }, yodleeManualDefaultConfig.security_option);

        return new Promise((resolve, reject) => {
            HttpRequest(options, (res) => {
                resolve(res);
            });
        });
    };

    /**
     * submitFilesUtil : analyse and classify uploaded docs
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const submitFilesUtil = () => {
        analyserUploadedDocs().then(res2 => {
            return classifyUploadedDocs();
        }).catch(err => {
            initScript.toggleLoader(false);
            if(analyser_status.ignoreParsingError){ //Ignore error for analyser
                $('#doneMessageID').css('display', 'block');
                toggleTargetProperty(true, true);
                $(".close").off("click");
                promiseResolve( { code: 200, type: 'analyser-response', status: 'success', data: err.analyserResponse} );
                if(analyser_status.hideManualDiv){
                    hideManualDiv(yodleeConfigObj.yodleeManual.class, yodleeConfigObj.yodleeManual.html.modal);
                }
            }
            else{ //Display error for analyser
                var err_msg = "Unable to parse."
                err_msg += (err.analyserResponse.errors["invalid_data"])? "\n\r "+err.analyserResponse.errors["invalid_data"]: "";
                initScript.getTargetIdentifierElement('#Failure').innerHTML =  err_msg;
                initScript.getHTMLElementByDelimiter('Failure', '#').css('display', 'block');
                // document.getElementById("doneMessageID").style.color = "red";   
                // promiseReject( {code: 400, type: 'analyser-response', status: 'failure', data: err.analyserResponse} )
            }
        }).then(res3 => { });
    };

    /**
     * submitFiles : submit uploaded docs for analyser and classify
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const submitFiles = () => {
        if (!linkedList.size_of_list()) return;
        initScript.toggleLoader(true);
        if (!!yodleeManualDefaultConfig.body.yodleeManual.delete_uploaded_docs_ref) {
            deleteManualReferences().then(res1 => {
                submitFilesUtil();
            });
        } else submitFilesUtil();
    };

    /**
     * hideManualDiv : hide manual div modal
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param templateClass string
     * @param templateModalOption object
     */
    const hideManualDiv = (templateClass, templateModalOption) => {
        if (templateModalOption !== 'none') {
            $(`.${templateClass}`)[0].innerHTML = '';
            $(`.${templateClass}`).removeAttr('style');
        }
    };

    return {
        main,
        widgetPromise,
        uploadFiles
    };
})();
